// extracted by mini-css-extract-plugin
module.exports = {"arrow":"styles__arrow___2TmO_","right":"styles__right___9UpoL","left":"styles__left___2GIC6","up":"styles__up___28HAs","down":"styles__down___3eNfp"};